export const SERVICES = [
  {
    slug: "passport-renewal",
    name: "Passport Renewal",
    category: "passport",
    seoTitle: "Passport Renewal Assistance | Travel Passport and Visa LLC",
    seoDescription:
      "Professional passport renewal assistance from a private Washington, DC company with 20+ years of experience. We help you prepare, review, and organize your renewal application. Call 866-334-8472.",
    h1: "Passport Renewal Assistance",
    tagline: "Professional help renewing your U.S. passport — organized, reviewed, and prepared correctly.",
    intro:
      "Renewing a passport sounds simple until forms, photo rules, name-change documents, and eligibility questions get in the way. Travel Passport and Visa LLC provides professional passport renewal assistance so your application materials are complete, accurate, and aligned with current U.S. Department of State requirements.",
    paragraphs: [
      "Our team helps you determine which renewal process applies to your situation — including whether you may be eligible to renew by mail or must apply in person — and assists with organizing the required forms, photos, supporting documents, and applicable fees.",
      "If your travel date is approaching, we can also help you understand what urgent options may exist under the applicable government process. Eligibility for expedited or urgent processing is determined by the U.S. Department of State, and processing times are estimates only and never guaranteed.",
    ],
    assistWith: [
      "Determining the correct renewal process for your situation",
      "Application form preparation and review",
      "Passport photo requirement guidance",
      "Name-change and supporting document organization",
      "Guidance on urgent travel options when time is short",
      "Clear explanation of government fees vs. our service fees",
    ],
    faqs: [
      {
        q: "Can I renew my passport by mail?",
        a: "Many travelers are eligible to renew by mail, depending on factors such as the condition and issuance date of their current passport. We help you confirm which process applies to you before you submit anything.",
      },
      {
        q: "How long does a passport renewal take?",
        a: "Processing times are set by the U.S. Department of State and vary by service level and current conditions. Any estimate is subject to change and is not guaranteed. Contact us for current estimated timeframes.",
      },
      {
        q: "What does your renewal assistance cost?",
        a: "There are two separate fees: mandatory government fees paid to the U.S. Department of State, and our professional service fee for assistance. We explain both clearly before you proceed.",
      },
    ],
    related: ["new-passport", "urgent-passport-assistance", "lost-stolen-passport"],
  },
  {
    slug: "new-passport",
    name: "New Passport",
    category: "passport",
    seoTitle: "New Passport Application Assistance | Travel Passport and Visa LLC",
    seoDescription:
      "First-time U.S. passport application assistance from a private Washington, DC company. We help you prepare forms, documents, and photos correctly. Call 866-334-8472.",
    h1: "New Passport Application Assistance",
    tagline: "Applying for your first U.S. passport? We help you get every detail right.",
    intro:
      "A first-time passport application requires proof of citizenship, proof of identity, a compliant photo, the correct form, and an in-person execution step at an acceptance facility. Travel Passport and Visa LLC guides you through each requirement so nothing is missed.",
    paragraphs: [
      "We help you identify acceptable citizenship and identity documents, prepare your application materials, and understand what to expect at your acceptance facility appointment and beyond.",
      "Travel Passport and Visa LLC is a private service provider. Applications are adjudicated by the U.S. Department of State, and processing times are estimates only — never guaranteed.",
    ],
    assistWith: [
      "Citizenship and identity document checklists",
      "DS-11 application preparation guidance",
      "Photo requirement guidance",
      "Acceptance facility process explanation",
      "Guidance for applicants with upcoming travel",
      "Transparent explanation of all applicable fees",
    ],
    faqs: [
      {
        q: "What documents do I need for a first passport?",
        a: "Generally you need proof of U.S. citizenship, proof of identity, a passport photo, and the completed application form. We provide a checklist tailored to your situation.",
      },
      {
        q: "Do I have to apply in person?",
        a: "First-time applicants typically must appear in person at a passport acceptance facility. We explain exactly what to bring and what happens at that appointment.",
      },
      {
        q: "Are you part of the government?",
        a: "No. Travel Passport and Visa LLC is a private service provider. Eligibility and issuance decisions are made by the U.S. Department of State.",
      },
    ],
    related: ["passport-renewal", "child-passport", "urgent-passport-assistance"],
  },
  {
    slug: "urgent-passport-assistance",
    name: "Urgent Passport Assistance",
    category: "passport",
    seoTitle: "Urgent Passport Assistance | Travel Passport and Visa LLC",
    seoDescription:
      "Urgent passport assistance for upcoming international travel. A private Washington, DC company helping you navigate time-sensitive options. Call 866-334-8472.",
    h1: "Urgent Passport Assistance",
    tagline: "Traveling soon? We help you understand and navigate time-sensitive passport options.",
    intro:
      "When international travel is days or weeks away and your passport isn't ready, every decision matters. Travel Passport and Visa LLC assists travelers with urgent passport needs by helping them understand which government processes may apply to their situation.",
    paragraphs: [
      "Depending on your travel date and eligibility, options under the applicable government process may include expedited processing or an appointment at a regional passport agency. Appointments, eligibility, and processing decisions are controlled by the U.S. Department of State.",
      "We move quickly and communicate clearly — but we never promise outcomes we don't control. Processing times are estimates only, and no private company can guarantee issuance by a specific date.",
    ],
    assistWith: [
      "Rapid assessment of your travel timeline and options",
      "Guidance on expedited processing eligibility",
      "Preparation for regional passport agency appointments",
      "Document and photo readiness review",
      "Clear, honest communication about what is and isn't possible",
      "Coordination for business travelers with urgent departures",
    ],
    faqs: [
      {
        q: "Can you get me a passport in 24 hours?",
        a: "No private company can promise a passport in a specific number of hours or days. Issuance is controlled by the U.S. Department of State. We help you understand which urgent options may be available and prepare your materials correctly.",
      },
      {
        q: "What qualifies as urgent travel?",
        a: "The U.S. Department of State defines eligibility for urgent and emergency services based on your travel date and circumstances. We help you determine which category fits your situation.",
      },
      {
        q: "What should I do first?",
        a: "Call us at 866-334-8472 or submit the form with your travel date and destination. The sooner we understand your timeline, the more options we can help you evaluate.",
      },
    ],
    related: ["passport-renewal", "lost-stolen-passport", "visa-assistance"],
  },
  {
    slug: "child-passport",
    name: "Child Passport",
    category: "passport",
    seoTitle: "Child Passport Assistance | Travel Passport and Visa LLC",
    seoDescription:
      "Child and minor passport application assistance. We help parents prepare consent documents, forms, and evidence correctly. Private company in Washington, DC. Call 866-334-8472.",
    h1: "Child Passport Assistance",
    tagline: "Passports for minors involve extra steps. We help parents navigate all of them.",
    intro:
      "Passport applications for children under 16 have additional requirements: both parents or guardians generally must consent, evidence of the parental relationship is required, and the child must appear in person. Travel Passport and Visa LLC helps families prepare every piece correctly.",
    paragraphs: [
      "We assist with consent documentation — including situations where one parent cannot appear — custody-related documentation, and the forms and evidence required for minors of any age, including 16- and 17-year-olds, whose applications follow different rules.",
      "Our team makes a complicated process feel organized and manageable, so your family's travel plans stay on track. Issuance decisions rest with the U.S. Department of State.",
    ],
    assistWith: [
      "Parental consent requirements and Form DS-3053 guidance",
      "Evidence of parental relationship checklists",
      "Applications for infants, children, and teens",
      "Renewals for children whose passports are expiring",
      "Guidance for single parents and custody situations",
      "Family travel document planning",
    ],
    faqs: [
      {
        q: "Do both parents need to be present?",
        a: "Generally, yes — both parents or guardians must consent for children under 16. When one parent cannot appear, a notarized consent form may be used. We walk you through the exact requirements for your family.",
      },
      {
        q: "How long is a child's passport valid?",
        a: "Passports for children under 16 are valid for five years. Passports for applicants 16 and older are valid for ten years.",
      },
      {
        q: "Can you help if our trip is soon?",
        a: "Yes. Contact us with your travel date and we'll explain which options may apply under the current government process. Timeframes are estimates and never guaranteed.",
      },
    ],
    related: ["new-passport", "passport-renewal", "urgent-passport-assistance"],
  },
  {
    slug: "lost-stolen-passport",
    name: "Lost or Stolen Passport",
    category: "passport",
    seoTitle: "Lost or Stolen Passport Assistance | Travel Passport and Visa LLC",
    seoDescription:
      "Lost or stolen passport? We help you report it, prepare replacement application materials, and understand your options. Private DC company. Call 866-334-8472.",
    h1: "Lost or Stolen Passport Assistance",
    tagline: "A missing passport doesn't have to derail your trip. We help you move forward.",
    intro:
      "Losing a passport — especially close to a departure date — is stressful. Travel Passport and Visa LLC helps you report the loss correctly, prepare your replacement application materials, and understand the options available under the applicable government process.",
    paragraphs: [
      "Replacing a lost or stolen passport generally requires a statement regarding the loss (Form DS-64) along with a new application (Form DS-11) submitted in person, plus citizenship evidence, identification, and a new photo.",
      "If your travel is imminent, we help you understand what urgent pathways may exist. Eligibility and processing decisions are made by the U.S. Department of State, and timeframes are estimates only.",
    ],
    assistWith: [
      "Reporting a lost or stolen passport correctly",
      "DS-64 and DS-11 form preparation guidance",
      "Replacement document checklists",
      "Options for travelers with near-term departures",
      "Guidance if your passport was lost abroad",
      "Clear explanation of all fees involved",
    ],
    faqs: [
      {
        q: "What should I do first if my passport is lost or stolen?",
        a: "Report it as lost or stolen as soon as possible — this invalidates the document and protects you. We then help you prepare the replacement application materials.",
      },
      {
        q: "Can I travel while my replacement is being processed?",
        a: "International travel requires a valid passport. If your departure is near, contact us and we'll explain which urgent options may be available under the current government process.",
      },
      {
        q: "Is my old passport valid if I find it later?",
        a: "No. Once reported lost or stolen, a passport is invalidated and cannot be used for travel, even if recovered.",
      },
    ],
    related: ["urgent-passport-assistance", "new-passport", "passport-renewal"],
  },
  {
    slug: "visa-assistance",
    name: "Visa Assistance",
    category: "visa",
    seoTitle: "Visa Assistance Services | Travel Passport and Visa LLC",
    seoDescription:
      "Professional visa application assistance for international travel. 20+ years of experience helping travelers prepare consular documentation. Call 866-334-8472.",
    h1: "Visa Assistance Services",
    tagline: "Professional help navigating visa requirements for destinations worldwide.",
    intro:
      "Every country sets its own visa rules — forms, photos, invitation letters, itineraries, financial evidence, and consular appointments vary widely. Travel Passport and Visa LLC provides professional visa assistance so your application materials align with the specific requirements of your destination.",
    paragraphs: [
      "We assist with tourist visas, business visas, and other common travel visa categories, helping you understand requirements, prepare documentation, and navigate the applicable consular process.",
      "Visa eligibility, processing, and issuance decisions are made solely by each embassy or consulate. We never guarantee approvals or processing times — we make sure your materials are complete, accurate, and professionally prepared.",
    ],
    assistWith: [
      "Destination-specific visa requirement research",
      "Application form preparation and review",
      "Supporting document checklists and organization",
      "Consular submission process guidance",
      "Tourist, business, and other visa categories",
      "Multi-country itinerary planning support",
    ],
    faqs: [
      {
        q: "Which countries do you assist with?",
        a: "We assist with visa documentation for destinations worldwide. Requirements change frequently, so contact us with your destination and nationality for current guidance.",
      },
      {
        q: "Can you guarantee my visa will be approved?",
        a: "No. Approval decisions are made solely by the embassy or consulate. Our role is professional preparation of your application materials.",
      },
      {
        q: "How far in advance should I start?",
        a: "As early as possible. Some consular processes take weeks, and appointments can be limited. Contact us with your travel date and we'll help you plan.",
      },
    ],
    related: ["tourist-visa", "business-visa", "document-authentication"],
  },
  {
    slug: "tourist-visa",
    name: "Tourist Visa",
    category: "visa",
    seoTitle: "Tourist Visa Assistance | Travel Passport and Visa LLC",
    seoDescription:
      "Tourist visa application assistance for leisure travel worldwide. We help you prepare consular documentation correctly. Private DC company. Call 866-334-8472.",
    h1: "Tourist Visa Assistance",
    tagline: "Focus on your trip — we'll help you handle the visa paperwork.",
    intro:
      "Planning a vacation abroad? Many destinations require U.S. travelers to obtain a visa in advance, and each consulate has its own forms, photo specifications, and supporting document rules. Travel Passport and Visa LLC helps you prepare a complete, accurate tourist visa application.",
    paragraphs: [
      "We assist with destination research, application preparation, document organization, and consular process guidance — for single trips, multi-country itineraries, and family travel.",
      "Tourist visa decisions are made by each country's embassy or consulate, and processing times vary. We keep you informed and prepared, without ever promising outcomes we don't control.",
    ],
    assistWith: [
      "Tourist visa requirement research for your destination",
      "Application form and photo preparation",
      "Itinerary, hotel, and financial document organization",
      "Family and group application coordination",
      "Multi-country trip visa planning",
      "Consular fee and process explanation",
    ],
    faqs: [
      {
        q: "Do I need a visa for my destination?",
        a: "It depends on your destination, nationality, and trip length. Contact us with your itinerary and we'll explain the current requirements.",
      },
      {
        q: "How long does a tourist visa take?",
        a: "Processing times are set by each embassy or consulate and vary widely. Estimates are subject to change and cannot be guaranteed.",
      },
      {
        q: "Can you help my whole family?",
        a: "Yes. We coordinate applications for couples, families, and groups traveling together.",
      },
    ],
    related: ["visa-assistance", "business-visa", "translation-services"],
  },
  {
    slug: "business-visa",
    name: "Business Visa",
    category: "visa",
    seoTitle: "Business Visa Assistance | Travel Passport and Visa LLC",
    seoDescription:
      "Business visa assistance for executives, employees, and consultants. Professional documentation support from a private Washington, DC company. Call 866-334-8472.",
    h1: "Business Visa Assistance",
    tagline: "International business moves fast. Your visa paperwork should keep up.",
    intro:
      "Business travel often involves tight timelines, invitation letters, corporate documentation, and consulates with exacting requirements. Travel Passport and Visa LLC assists executives, employees, consultants, and international teams with business visa application preparation.",
    paragraphs: [
      "We help you understand the correct visa category for your activities, prepare application forms, and organize supporting documents such as invitation letters, employer letters, and itineraries.",
      "For organizations managing multiple travelers, we provide coordinated support so your team is documentation-ready. See our business and corporate travel services for details.",
    ],
    assistWith: [
      "Business visa category and requirement guidance",
      "Invitation letter and employer letter checklists",
      "Application form preparation and review",
      "Support for executives and frequent travelers",
      "Multi-destination business itinerary planning",
      "Coordination for teams and corporate accounts",
    ],
    faqs: [
      {
        q: "What documents are typically needed for a business visa?",
        a: "Common requirements include an invitation letter from the host company, a letter from your employer, an application form, photos, and itinerary details. Exact requirements vary by country — we confirm them for your destination.",
      },
      {
        q: "Can you handle visas for our whole team?",
        a: "Yes. We regularly coordinate documentation for multiple travelers within the same organization. Call 866-334-8472 to discuss your team's needs.",
      },
      {
        q: "How long does business visa processing take?",
        a: "Each consulate sets its own processing times, which vary by country and current conditions. Estimates are subject to change and never guaranteed.",
      },
    ],
    related: ["visa-assistance", "business-corporate-travel", "tourist-visa"],
  },
  {
    slug: "apostille-services",
    name: "Apostille Services",
    category: "documents",
    seoTitle: "Apostille Services | Travel Passport and Visa LLC",
    seoDescription:
      "Apostille assistance for documents used abroad — birth certificates, corporate documents, powers of attorney, and more. Washington, DC. Call 866-334-8472.",
    h1: "Apostille Services",
    tagline: "Documents destined for use overseas often need an apostille. We help you get it right.",
    intro:
      "When U.S. documents are presented in countries that participate in the Hague Apostille Convention, they typically require an apostille certificate from the appropriate state or federal authority. Travel Passport and Visa LLC assists with preparing and navigating the apostille process.",
    paragraphs: [
      "We assist with apostilles for vital records, corporate documents, powers of attorney, academic records, and other documents intended for international use, helping you identify the correct issuing authority and prepare your materials.",
      "Apostilles are issued by government authorities — processing times and requirements are set by those offices and are subject to change.",
    ],
    assistWith: [
      "Identifying the correct apostille authority (state or federal)",
      "Document preparation and notarization guidance",
      "Vital records, corporate, and personal document apostilles",
      "Multi-document and corporate batch coordination",
      "Guidance for non-Hague countries requiring authentication",
      "Transparent fee explanation before work begins",
    ],
    faqs: [
      {
        q: "What is an apostille?",
        a: "An apostille is a certificate that authenticates a document for use in another country that participates in the Hague Apostille Convention. It is issued by a designated government authority.",
      },
      {
        q: "Which documents can be apostilled?",
        a: "Common examples include birth and marriage certificates, corporate documents, powers of attorney, and academic records. Requirements depend on the document type and destination country.",
      },
      {
        q: "How long does an apostille take?",
        a: "Processing times are set by the issuing government office and vary. Estimates are subject to change and cannot be guaranteed.",
      },
    ],
    related: ["document-authentication", "translation-services", "visa-assistance"],
  },
  {
    slug: "document-authentication",
    name: "Document Authentication",
    category: "documents",
    seoTitle: "Document Authentication Services | Travel Passport and Visa LLC",
    seoDescription:
      "Document authentication and embassy legalization assistance for international use of U.S. documents. Private Washington, DC company. Call 866-334-8472.",
    h1: "Document Authentication Services",
    tagline: "For countries outside the Hague Convention, documents need full authentication. We guide the process.",
    intro:
      "Documents destined for countries that do not participate in the Hague Apostille Convention generally require a multi-step authentication and embassy legalization process. Travel Passport and Visa LLC assists with preparing and navigating each step.",
    paragraphs: [
      "The authentication chain may involve state certification, U.S. Department of State authentication, and legalization by the destination country's embassy. We help you understand the sequence for your specific documents and destination.",
      "Each step is performed by a government office or consulate with its own requirements, fees, and processing times, all of which are subject to change.",
    ],
    assistWith: [
      "Authentication requirement research by destination country",
      "State and federal certification process guidance",
      "Embassy legalization preparation",
      "Corporate and personal document handling",
      "Multi-step process coordination and tracking",
      "Clear separation of government fees and service fees",
    ],
    faqs: [
      {
        q: "What's the difference between an apostille and authentication?",
        a: "Apostilles apply to Hague Convention countries. For non-Hague countries, documents typically go through a longer authentication and embassy legalization process. We identify which path your destination requires.",
      },
      {
        q: "Can you authenticate corporate documents?",
        a: "Yes. We assist with corporate documents such as certificates of incorporation, powers of attorney, and commercial documents intended for use abroad.",
      },
      {
        q: "How long does authentication take?",
        a: "Each government office and embassy sets its own processing times. Multi-step processes take longer, and all estimates are subject to change.",
      },
    ],
    related: ["apostille-services", "translation-services", "business-corporate-travel"],
  },
  {
    slug: "translation-services",
    name: "Translation Services",
    category: "documents",
    seoTitle: "Translation Services for Travel Documents | Travel Passport and Visa LLC",
    seoDescription:
      "Document translation assistance for visa, passport, and international document applications. Professional, accurate, travel-ready. Call 866-334-8472.",
    h1: "Translation Services",
    tagline: "When applications require translated documents, accuracy is everything.",
    intro:
      "Visa applications, apostilles, and international document submissions often require certified or official translations of supporting documents. Travel Passport and Visa LLC assists with translation services for travel and legal documentation.",
    paragraphs: [
      "We help you identify which documents require translation for your specific application, coordinate professional translation, and ensure translated materials are formatted to the requirements of the receiving consulate or authority.",
      "Translation requirements vary by destination and document type. We confirm the current requirements before work begins so nothing has to be redone.",
    ],
    assistWith: [
      "Translation requirement research for your application",
      "Certified translation coordination",
      "Vital records, legal, and corporate document translation",
      "Formatting to consular specifications",
      "Combined translation + apostille/authentication workflows",
      "Clear, upfront fee explanation",
    ],
    faqs: [
      {
        q: "Do I need a certified translation?",
        a: "Many consulates and government offices require certified translations of foreign-language documents. We confirm the exact requirement for your destination and document type.",
      },
      {
        q: "Which languages do you support?",
        a: "We coordinate translations across many language pairs. Contact us with your documents and destination for specifics.",
      },
      {
        q: "Can translation be combined with an apostille?",
        a: "Often yes — translated documents sometimes also require an apostille or authentication. We coordinate the full workflow in the correct order.",
      },
    ],
    related: ["apostille-services", "document-authentication", "visa-assistance"],
  },
  {
    slug: "business-corporate-travel",
    name: "Business & Corporate Travel",
    category: "business",
    seoTitle: "Corporate Passport & Visa Services | Travel Passport and Visa LLC",
    seoDescription:
      "Passport, visa, and travel-document assistance for businesses, executives, and employees. 20+ years of experience in Washington, DC. Call 866-334-8472.",
    h1: "Business & Corporate Travel Documentation",
    tagline: "Keep your executives, employees, and international teams ready to travel.",
    intro:
      "When business takes your people abroad, documentation problems become business problems. Travel Passport and Visa LLC provides professional passport, visa, and travel-document assistance for companies, executives, employees, consultants, and international teams.",
    paragraphs: [
      "We work with executive assistants, HR teams, travel managers, and mobility coordinators to keep employee passports current, prepare business visa applications, and handle document authentication for international assignments.",
      "From a single executive trip to ongoing support for frequent travelers, our Washington, DC team provides organized, responsive assistance built around your travel schedule.",
    ],
    assistWith: [
      "Executive and employee passport services",
      "Business visa application preparation",
      "Document authentication for international assignments",
      "Support for HR, travel managers, and executive assistants",
      "Multi-traveler coordination for teams and projects",
      "Responsive assistance for time-sensitive departures",
    ],
    faqs: [
      {
        q: "Can you support our company on an ongoing basis?",
        a: "Yes. Many organizations rely on us for continuing support of their travelers. Call 866-334-8472 to discuss your business needs.",
      },
      {
        q: "Do you handle multiple travelers at once?",
        a: "Yes. We coordinate documentation for teams, project groups, and entire departments traveling internationally.",
      },
      {
        q: "Are you a government agency?",
        a: "No. Travel Passport and Visa LLC is a private service provider. Government agencies make all eligibility, processing, and approval decisions.",
      },
    ],
    related: ["business-visa", "urgent-passport-assistance", "document-authentication"],
  },
];

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);

export const CATEGORY_LABELS = {
  passport: "Passport Services",
  visa: "Visa Services",
  documents: "Travel Document Services",
  business: "Business Services",
};
